import { generatePath } from 'react-router-dom';

import {
  API_REPORTING_HUB_REPORT_DOWNLOAD_URL,
  API_REPORTING_TEMPLATE_DELETE_URL,
  API_REPORTING_TEMPLATE_EDIT_URL,
  API_REPORTING_TEMPLATE_LIST_URL,
  API_REPORTING_TEMPLATE_NEW_URL,
  API_REPORTING_TEMPLATE_SHOW_URL,
} from '../../constants/apiUrls';
import mapFormToReportTemplate from '../../util/mapFormToReportTemplate';
import { deleteRequestJSON, getRequestJSON, postRequestJSON } from '../../util/services';
import { ReportTemplate } from '../../validationSchemas/ReportTemplateSchema';

export const create = (apiHost: string, userId: number, template: ReportTemplate): Promise<any> =>
  postRequestJSON(
    apiHost,
    generatePath(API_REPORTING_TEMPLATE_NEW_URL, {
      userId: userId.toString(),
    }),
    mapFormToReportTemplate(template)
  );

export const update = (apiHost: string, userId: number, template: ReportTemplate): Promise<any> =>
  postRequestJSON(
    apiHost,
    generatePath(API_REPORTING_TEMPLATE_EDIT_URL, {
      userId: userId.toString(),
      reportTemplateId: template.templateId.toString(),
    }),
    mapFormToReportTemplate(template)
  );

export const getAllByUserIds = (apiHost: string, userIds: number[]): Promise<any> =>
  new Promise((resolve, reject) => {
    const returnValue = { collection: [], meta: undefined };
    const getHelper = async () => {
      userIds.forEach(async (userId, index) => {
        try {
          const templateList = await getRequestJSON(
            apiHost,
            generatePath(API_REPORTING_TEMPLATE_LIST_URL, {
              userId: userId.toString(),
            })
          );
          returnValue.collection = returnValue.collection.concat(templateList.collection);
          returnValue.meta = templateList.meta;

          if (index === userIds.length - 1) {
            resolve(returnValue);
          }
        } catch (e) {
          reject(e);
        }
      });
    };

    getHelper();
  });

export const get = (apiHost: string, reportTemplateId: number): Promise<any> =>
  getRequestJSON(
    apiHost,
    generatePath(API_REPORTING_TEMPLATE_SHOW_URL, {
      reportTemplateId: reportTemplateId.toString(),
    })
  );

export const remove = (apiHost: string, userId: number, reportTemplateId: number): Promise<any> =>
  deleteRequestJSON(
    apiHost,
    generatePath(API_REPORTING_TEMPLATE_DELETE_URL, {
      userId: userId.toString(),
      reportTemplateId: reportTemplateId.toString(),
    })
  );

export const download = (apiHost: string, reportTemplateId: number, options: { signal?: AbortSignal }): Promise<any> =>
  postRequestJSON(
    apiHost,
    generatePath(API_REPORTING_HUB_REPORT_DOWNLOAD_URL, {
      reportTemplateId: reportTemplateId.toString(),
    }),
    {},
    undefined,
    options
  );
